import React from 'react';
import { Avatar, Row } from 'antd';
import { titlize, getRandomHexColor } from '../../../../utils/strings';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Dropdown from '../../dropdown/dropdown';
import classes from './navigation-items.module.css';
import styled, { useTheme } from 'styled-components';
import { useMedia } from '../../../../hooks';
import { AppRoutes, screenWidths } from '../../../../enums';

const NavLinkContainer = styled.li<{ media: keyof typeof screenWidths }>`
	display: inline-block;

	a:link,
	a:visited {
		color: rgba(255, 255, 255, 0.5);
	}

	a:hover,
	a:active {
		color: rgba(255, 255, 255, 0.8);
	}

	@media (min-width: ${({ media }) => screenWidths[media]}) {
		 {
			display: inline-block;
		}
	}
`;

const NavigationItems = ({ isAuthenticated, user, media }) => {
	let navItems;
	let view = useMedia(media);
	const location = useLocation();
	const theme = useTheme();

	if (!isAuthenticated || !user) {
		navItems = (
			<>
				<NavLinkContainer media={media} className={`btn`}>
					<NavLink
						className={({ isActive }) =>
							isActive ? 'nav-link--active nav-link link-main-light' : 'nav-link link-main-light'
						}
						to="/signin"
					>
						Login
					</NavLink>
				</NavLinkContainer>
				{/\/signup/g.test(location.pathname) ? null : (
					<NavLinkContainer media={media} className={`btn`}>
						<Link className="nav-link btn-main btn-main-primary link-main-primary" to={AppRoutes.SIGNUP}>
							Sign up
						</Link>
					</NavLinkContainer>
				)}
				{/* <li className='btn'>
                        <Link className="nav-link btn-main btn-main-light link-main-light"
                            to="/aaa"
                        >
                            Employer?
                        </Link>
                    </li> */}
			</>
		);
	} else {
		navItems = (
			<>
				<NavLinkContainer media={media} className={`btn`}>
					<NavLink
						className={({ isActive }) =>
							isActive ? 'nav-link--active nav-link link-main-light' : 'nav-link link-main-light'
						}
						to={AppRoutes.PERKS}
					>
						Our perks
					</NavLink>
				</NavLinkContainer>

				<NavLinkContainer media={media} className={`btn`}>
					<NavLink
						className={({ isActive }) =>
							isActive ? 'nav-link--active nav-link link-main-light' : 'nav-link link-main-light'
						}
						to={AppRoutes.OUTSOURCING}
					>
						Outsource
					</NavLink>
				</NavLinkContainer>
				<li className="btn ms-0">
					<Dropdown media={media} backOffice>
						<a className="d-inline-block">
							{view ? (
								<span style={{ color: theme.TA_GREEN, fontSize: 14, marginLeft: '1rem' }}>
									Hello, {`${titlize(user.firstName)}`}
								</span>
							) : null}

							<Avatar
								size={40}
								src={user.avatar || null}
								shape="circle"
								style={{
									backgroundColor: user.avatarBgColor,
									marginLeft: '1rem'
								}}
							>
								<span style={{ mixBlendMode: 'difference' }}>{`${titlize(user.firstName[0])}${titlize(
									user.lastName[0]
								)}`}</span>
							</Avatar>
						</a>
					</Dropdown>
				</li>
			</>
		);
	}
	return <ul className={classes.NavItems}>{navItems}</ul>;
};

export default NavigationItems;
